module.exports = "/fonts/opensansextrabold.woff2";